export function toPercent(floatValue) {
  return 100*floatValue + '%';
}